import type {BuildTypeId} from '../../../../../../types'

export enum BranchesToShow {
  DEFAULT,
  NON_DEFAULT,
  NON_BUILT,
}

type OwnProps = {
  branchesToShow: BranchesToShow
  withTitle?: boolean
}
export type ReduxOwnProps = OwnProps & {
  buildTypeId?: BuildTypeId
}
export type StateProps = {
  expanded: boolean
}
export type ActionProps = {
  onCollapse: (id: BuildTypeId, branchesToShow: BranchesToShow) => unknown
  onExpand: (id: BuildTypeId, branchesToShow: BranchesToShow) => unknown
}
export type Props = ReduxOwnProps & StateProps & ActionProps
